import wallet1 from './Images/wallet1.png'
import wallet2 from './Images/wallet2.png'
import wallet3 from './Images/wallet3.png'
import wallet4 from './Images/wallet4.png'
import wallet5 from './Images/wallet5.png'
import wallet6 from './Images/wallet6.png'
import wallet7 from './Images/wallet7.png'
import wallet8 from './Images/wallet8.png'
import wallet9 from './Images/wallet9.png'
import wallet10 from './Images/wallet10.png'
import wallet11 from './Images/wallet11.png'
import wallet12 from './Images/wallet12.png'
import wallet13 from './Images/wallet13.png'
import wallet14 from './Images/wallet14.png'
import wallet15 from './Images/wallet15.png'
import wallet16 from './Images/wallet16.png'
import wallet17 from './Images/wallet17.png'
import wallet18 from './Images/wallet18.png'
import wallet19 from './Images/wallet19.png'
import wallet20 from './Images/wallet20.png'
import wallet21 from './Images/wallet21.png'


const WalletDet = [
    {
        id: 1,
        name: "Oliver Black Leather Wallet for Men, 6 Card Slot",
        brand: "URBAN FOREST",
        price: 449,
        image: wallet1,
        style: "Contemporary"
    },
    {
        id: 2,
        name: "Lavie Women's Safain Trifold Wallet | Ladies Purse Handbag",
        brand: "Lavie",
        price: 409,
        image: wallet2,
        style: "Safain Small"
    },
    {
        id: 3,
        name: "HORNBULL Denial Navy Leather Wallet for Men",
        brand: "HORNBULL",
        price: 399,
        image: wallet3,
        style: "Two Fold Wallet"
    },
    {
        id: 4,
        name: "Women's Vegan Leather Tri-fold Fashion Card Coin Holder Small Wallet",
        brand: "INOVERA",
        price: 419,
        image: wallet4,
        style: "Wallet"
    },
    {
        id: 5,
        name: "WildHorn RFID Protected Leather Wallet for Men",
        brand: "WildHorn",
        price: 284,
        image: wallet5,
        style: "Classic"
    },
    {
        id: 6,
        name: "Valerie Women Wallet Wallet for Women and Girls",
        brand: "Valerie",
        price: 358,
        image: wallet6,
        style: "Wallet"
    },
    {
        id: 7,
        name:  "Doger Olive Green Leather Wallet For Men, 2 Card Slot",
        brand: "Rigohill",
        price: 439,
        image: wallet7,
        style: "Casual"
    },
    {
        id: 8,
        name: "Women's Zip Wallet | Made with Vegan Leather Material",
        brand: "DailyObjects",
        price: 721,
        image: wallet8,
        style: "Wallet"
    },
    {
        id: 9,
        name: "London Alley Elk Vintage Brown Leather Wallet For Men, 6 Card Slot",
        brand: "London Alley",
        price: 479,
        image: wallet9,
        style: "Vintage"
    },
    {
        id: 10,
        name: "ZOUK Women's Handcrafted Classic Chain Wallet",
        brand: "ZOUK",
        price: 484,
        image: wallet10,
        style: "Wallet"
    },
    {
        id: 11,
        name: "Men's Personalized Wallet I Customized Slim Stylish Leather Purse",
        brand: "Innovative Gifts",
        price: 419,
        image: wallet11,
        style: "Modern"
    },
    {
        id: 12,
        name: "Funk For Hire Women Printed Petrol Blue Leatherette Wallet",
        brand: "Funk For Hire",
        price: 633,
        image: wallet12,
        style: "Modern"
    },
    {
        id: 13,
        name: "The Wallet Store Urban Pop RFID Protection Wallet",
        brand: "The Wallet Store",
        price: 1394,
        image: wallet13,
        style: "Casual"
    },
    {
        id: 14,
        name: "Niwlix Leather Small Wallet For Women Slim Mini Wallet ",
        brand: "Niwlix",
        price: 378,
        image: wallet14,
        style: "Classic"
    },
    {
        id: 15,
        name: "Felix Men's Leather Wallet - Brown (4 Card Slot)",
        brand: "Tommy Hilfiger",
        price: 999,
        image: wallet15,
        style: "Casual"
    },
    {
        id: 16,
        name: "ShopMantra Wallet for Women's |Clutch |Vegan Leather",
        brand: "ShopMantra",
        price: 495,
        image: wallet16,
        style: "Casual"
    },
    {
        id: 17,
        name: "Scarters Faux Leather Abundance Wallet For Men ",
        brand: "Scarters",
        price: 2424,
        image: wallet17,
        style: "Minimalist"
    },
    {
        id: 18,
        name: "PALAY® Women's Long Wallet Tassel PU Leather",
        brand: "PALAY®",
        price: 399,
        image: wallet18,
        style: "Diaper Bags"
    },
    {
        id: 19,
        name: "Leo Vintage Cognac Leather Wallet for Men",
        brand: "URBAN FOREST",
        price: 449,
        image: wallet19,
        style: "Vintage"
    },
    {
        id: 20,
        name: "Unisex Adult Spencer Leather Wallet Combo Gift Set",
        brand: "URBAN FOREST",
        price: 1309,
        image: wallet20,
        style: "Modern"
    },
    {
        id: 21,
        name: "Fastrack Grey And Red Leather Men's Wallet ",
        brand: "Fastrack",
        price: 876,
        image: wallet21,
        style: "Wallets"
    }
]
export default WalletDet